/**
 * Vue filter to decode html
 *
 * @param {String} value    The value string.
 */

import Vue from 'vue'

const decode = require('unescape')

Vue.filter('decode', (value: any) => {
  return decode(value)
})
